<ng-container *ngIf="selectedKpiByKey">
  <div class="kpi-charts-side-panel-body">
    <div class="kpi-charts-side-panel-header">
      <span>
        {{ kpiDisplaySecondaryValue ?? '--' }}
      </span>
      <span> | </span>
      <span>
        {{ kpiDisplayValue + (kpiDisplayUnit ?? '') }}
      </span>
      <span> | </span>

      <kpi-trend-indicator
        [trendIndicator]="selectedKpiByKey.kpi.trendIndicator"
        [trendChange]="selectedKpiByKey.kpi.trendChange"
        [kpiType]="selectedKpiByKey.kpi.type"
        [kpiName]="selectedKpiByKey.kpi.name"
        [showPlaceholder]="true"
      >
      </kpi-trend-indicator>

      <status-badge
        *ngIf="selectedKpiByKey.kpi.health as health"
        [type]="'kpiHealth'"
        [badgeKey]="health"
        class="kpi-charts-side-panel-health-badge"
      ></status-badge>
    </div>
    <div class="kpi-charts-side-panel-contents">
      <ng-container *ngFor="let chartConfig of kpiChartsConfig">
        <ng-container [ngSwitch]="chartConfig.type">
          <ng-container *ngSwitchCase="'trendchart'">
            <drilldown-chart-container
              *ngIf="kpiChartData[selectedKpiByKey.key]?.charts?.trendchart as trendChartData"
              [title]="trendChartData.titleSuffix"
              [infoText]="trendChartData.tooltipText"
              [size]="'small'"
              [isLoading]="(chartsAreLoading$ | async) ?? false"
            >
              <trend-chart
                chart-element
                *ngIf="(chartsAreLoading$ | async) === false"
                [size]="chartSize"
                [trendChartData]="trendChartData"
              ></trend-chart>
            </drilldown-chart-container>
          </ng-container>

          <ng-container *ngSwitchCase="'keyMilestonesTable'">
            <drilldown-chart-container
              *ngIf="
                kpiChartData[selectedKpiByKey.key]?.charts?.keyMilestonesTable as keyMilestonesTable
              "
              [title]="keyMilestonesTable.title"
              [infoText]="keyMilestonesTable.tooltipInfo"
              [size]="'small'"
              [isLoading]="(chartsAreLoading$ | async) ?? false"
            >
              <drilldown-table
                chart-element
                [data]="keyMilestonesTable"
                [size]="chartSize"
              ></drilldown-table>
            </drilldown-chart-container>
          </ng-container>

          <ng-container *ngSwitchCase="'bar'">
            <drilldown-chart-container
              *ngIf="getBarChartData(chartConfig.id) as barChartData"
              [title]="barChartData.titleSuffix"
              [infoText]="barChartData.tooltipText"
              [size]="'small'"
              [isLoading]="(chartsAreLoading$ | async) ?? false"
            >
              <chart
                chart-element
                *ngIf="(chartsAreLoading$ | async) === false"
                [sortedData]="barChartData.values"
                [initOption]="initKpiOption"
                [chartOption]="bar"
                [kpiChartSize]="chartSize"
                [kpiOnTrack]="barChartData.onTrack"
                [kpiOnTarget]="barChartData.onTarget"
                [isPercent]="barChartData.config?.isPercent ?? false"
                [showAllKeys]="false"
                [kpiAxisKeysShownDefault]="barChartData.yAxisLabelCount?.small"
                [kpiXAxisLabel]="barChartData.xAxisLabel"
                [kpiChartIdentifier]="barChartData.identifier"
              ></chart>
            </drilldown-chart-container>
          </ng-container>

          <ng-container *ngSwitchCase="'pie'">
            <drilldown-chart-container
              *ngIf="getPieChartData(chartConfig.id) as pieChartData"
              [title]="pieChartData.titleSuffix"
              [infoText]="pieChartData.tooltipText"
              [size]="'small'"
              [isLoading]="(chartsAreLoading$ | async) ?? false"
            >
              <chart
                chart-element
                *ngIf="(chartsAreLoading$ | async) === false"
                [sortedData]="pieChartData.values"
                [isPercent]="pieChartData.config?.isPercent ?? false"
                [chartOption]="pie"
                [kpiChartSize]="chartSize"
                [colorMap]="colorMap"
                [showAllKeys]="false"
                [kpiAxisKeysShownDefault]="5"
                [kpiChartIdentifier]="pieChartData.identifier"
              ></chart>
            </drilldown-chart-container>
          </ng-container>

          <ng-container *ngSwitchCase="'toggleChart'">
            <drilldown-chart-container
              *ngIf="getToggleChartData(chartConfig.id) as toggleChartData"
              [title]="toggleChartData.titleSuffix"
              [infoText]="toggleChartData.tooltipText"
              [size]="'small'"
              [isLoading]="(chartsAreLoading$ | async) ?? false"
            >
              <drilldown-toggle-chart
                chart-element
                *ngIf="(chartsAreLoading$ | async) === false"
                [toggleChartData]="toggleChartData"
                [chartSize]="chartSize"
              ></drilldown-toggle-chart>
            </drilldown-chart-container>
          </ng-container>

          <ng-container *ngSwitchCase="'groupedBar'">
            <drilldown-chart-container
              *ngIf="getGroupedBarChartData(chartConfig.id) as groupedBarChartData"
              [title]="groupedBarChartData.titleSuffix"
              [infoText]="groupedBarChartData.tooltipText"
              [size]="'small'"
              [isLoading]="(chartsAreLoading$ | async) ?? false"
            >
              <grouped-bar-chart
                chart-element
                *ngIf="(chartsAreLoading$ | async) === false"
                [sortedData]="groupedBarChartData.values"
                [initOption]="initKpiOption"
                [chartOption]="groupedBar"
                [kpiChartSize]="chartSize"
                [kpiOnTrack]="groupedBarChartData.onTrack"
                [kpiOnTarget]="groupedBarChartData.onTarget"
                [isPercent]="groupedBarChartData.config?.isPercent ?? false"
                [showAllKeys]="false"
                [kpiAxisKeysShownDefault]="groupedBarChartData.yAxisLabelCount?.small"
                [kpiXAxisLabel]="groupedBarChartData.xAxisLabel"
                [kpiChartIdentifier]="groupedBarChartData.identifier"
              ></grouped-bar-chart>
            </drilldown-chart-container>
          </ng-container>

          <ng-container *ngSwitchCase="'timeCycleChart'">
            <drilldown-chart-container
              *ngIf="kpiChartData[selectedKpiByKey.key]?.charts?.timeCycleChart as timeCycleChart"
              [title]="timeCycleChart.title"
              [infoText]="timeCycleChart.tooltipText"
              [size]="'small'"
              [isLoading]="(chartsAreLoading$ | async) ?? false"
            >
              <time-cycle-chart
                chart-element
                [chartData]="timeCycleChart"
                [size]="'small'"
                *ngIf="(chartsAreLoading$ | async) === false"
              >
              </time-cycle-chart>
            </drilldown-chart-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>
  <kpi-charts-expanded-panel
    *ngIf="expandedPanelExpanded"
    [selectedKpiByKey]="selectedKpiByKey"
    [protocolNumber]="protocolNumber"
    [kpiChartsConfig]="kpiChartsConfig"
    (closeButtonClicked)="expandedPanelCloseButtonClicked()"
  ></kpi-charts-expanded-panel>
</ng-container>
